import { SplitScreen } from 'components/SplitScreen/SplitScreen';
import Item from 'components/Item/Item';
import Search from 'components/Search/Search';
import { Filters } from 'components/Filters/Filters';
import ListAwait from 'components/List/ListAwait';
import ListItem from 'components/List/ListItem';
import React, { useState } from 'react'
import { NavLink, Outlet, useLoaderData } from 'react-router-dom'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { Trans, useTranslation } from 'react-i18next';

const Suppliers = () => {
	let { suppliers } = useLoaderData();

	const [items, setItems] = useState();
	const [hasMore, setHasMore] = useState(false);

	const { t } = useTranslation();

	const handleLoad = (response) => {
		setItems(oldItems => [...oldItems, ...response.data]);
		setHasMore(response.next_page_url);
	};

	//callback function of Await react-router-dom
	const resolvedPromise = (response) => {
		if (items == null || items.length == 0) {
			setItems(response.data.data);
			setHasMore(response.data.next_page_url);
		}
	}

	return (
		<SplitScreen name="suppliers-list" leftClass="flex-column h-100 w-100">
			<Item>
				<div className='row g-2 align-items-center mb-2'>
					<div className='col'>
						<NavLink to={"./new"} end className='btn btn-info shadow-sm text-white d-block text-truncate'><Trans i18nKey="suppliers.new" /></NavLink>
					</div>
					<div className='col-auto'>
						<button
							className="btn border shadow-sm"
							type="button" data-bs-toggle="offcanvas"
							data-bs-target="#suppliers-filter" aria-controls="suppliers-filter"
							title={t("suppliers.filters.title")}>
							<i className="mdi mdi-filter-variant"></i>
						</button>
					</div>
				</div>
				<div className='row g-2 align-items-center'>
					<div className='col-12'>
						<Search action="/suppliers" />
					</div>
				</div>
				<div className="offcanvas offcanvas-start position-absolute bg-white rounded border-0 w-100" data-bs-backdrop="false" tabIndex="-1" id="suppliers-filter" aria-labelledby="suppliers-filter-label">
					<div className="offcanvas-header p-3 text-truncate">
						<h5 className="offcanvas-title" id="suppliers-filter-label"><Trans i18nKey="suppliers.filters.title" /></h5>
						<button type="button" className="btn-close" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasResponsive" aria-label="Close"></button>
					</div>
					<div className="offcanvas-body p-2">
						<OverlayScrollbarsComponent
							options={{
								showNativeOverlaidScrollbars: false,
								overflow: { x: "hidden" },
								scrollbars: { autoHide: "leave", autoHideDelay: 1300 },
							}}
							defer
							style={{ height: '100%' }}
						>
							<Filters action="/suppliers">
								{/* //TODO:: da fare  */}
							</Filters>
						</OverlayScrollbarsComponent>
					</div>
				</div>

				<ListAwait resolvePromise={suppliers} hasResolved={resolvedPromise} loadMore={handleLoad} hasMore={hasMore}>
					{items?.map((item, idx) =>
						<ListItem key={idx} item={item} />
					)}
				</ListAwait>

			</Item>
			<Outlet />
		</SplitScreen>
	)
}

export default Suppliers